import { __awaiter, __generator } from "tslib";
import { ContentOpenPreference, } from '@office-start/launcher-types';
import { getUserPreferenceService } from '@office-start/user-preference-service';
import { getCapabilitiesAndContext } from './getCapabilitiesAndContext';
import { launchInDesktop } from './launchInDesktop';
import { launchInline } from './launchInline';
import { launchInWeb } from './launchInWeb';
/**
 * Attempts to launch a document based on the current user's preferences and return the result
 * Will return { success: false } if no preference is set or available
 * @param contentLaunchParams
 * @param launchInstrumentationParams
 * @returns A promise containing the result of attempting to boot with user preferences
 */
export function launchDocumentWithUserPreferences(contentLaunchParams, launchInstrumentationParams) {
    return __awaiter(this, void 0, void 0, function () {
        var workload, userPreferenceService, userContentPreferences, launchResult, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getCapabilitiesAndContext()];
                case 1:
                    workload = (_b.sent()).workload;
                    return [4 /*yield*/, getUserPreferenceService(workload)];
                case 2:
                    userPreferenceService = _b.sent();
                    return [4 /*yield*/, (userPreferenceService === null || userPreferenceService === void 0 ? void 0 : userPreferenceService.getContentLaunchPreference())];
                case 3:
                    userContentPreferences = _b.sent();
                    _a = userContentPreferences;
                    switch (_a) {
                        case ContentOpenPreference.Desktop: return [3 /*break*/, 4];
                        case ContentOpenPreference.Inline: return [3 /*break*/, 6];
                        case ContentOpenPreference.Web: return [3 /*break*/, 8];
                    }
                    return [3 /*break*/, 10];
                case 4: return [4 /*yield*/, launchInDesktop(contentLaunchParams.document, launchInstrumentationParams)];
                case 5:
                    launchResult = _b.sent();
                    return [3 /*break*/, 11];
                case 6: return [4 /*yield*/, launchInline(contentLaunchParams, launchInstrumentationParams)];
                case 7:
                    launchResult = _b.sent();
                    return [3 /*break*/, 11];
                case 8: return [4 /*yield*/, launchInWeb(contentLaunchParams, launchInstrumentationParams)];
                case 9:
                    launchResult = _b.sent();
                    return [3 /*break*/, 11];
                case 10:
                    launchResult = { success: false };
                    _b.label = 11;
                case 11: return [2 /*return*/, launchResult];
            }
        });
    });
}
//# sourceMappingURL=launchDocumentWithUserPreferences.js.map